var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgJumpBackwardLarge = function SvgJumpBackwardLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.217 22.652h2.64V12.597h-2.174l-.028.113c-.127.664-.368 1.13-.777 1.426-.424.311-.974.466-1.723.466h-.424v1.766h2.486zM18.863 22.906c2.585 0 4.166-1.455 4.166-3.686 0-2.076-1.384-3.347-3.375-3.347-.762 0-1.497.184-2.033.58l-.043-.029.325-1.723h4.42v-2.104h-6.326l-.918 5.522 2.372.212c.382-.424.848-.608 1.398-.608 1.06 0 1.652.664 1.652 1.554 0 .918-.62 1.567-1.652 1.567-.833 0-1.412-.424-1.581-1.172l-2.514.198c.268 1.99 1.878 3.036 4.11 3.036"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2.577,
    d: "M2.577 17.752c0 7.116 5.77 12.885 12.886 12.885 7.117 0 12.886-5.769 12.886-12.885 0-7.117-5.77-12.886-12.886-12.886"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 2.577,
    d: "m17.964 8.77-3.79-3.79L18.154 1"
  })));
};
export default SvgJumpBackwardLarge;